<style lang="scss">
@import "@assets/styles/variables.scss"; //公共样式变量

.vue-body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .el-aside {
    width: auto !important;
    .side-bar {
      height: 100%;
      flex-shrink: 0;
    }
  }
  .body-container {
    height: 100%;
    .el-header {
      padding: 0;
    }
    .el-main {
      width: 100%;
      padding: 0;
      height: calc(100% );
      .app-main {
        width: 100%;
        height: 100%;
      }
    }
    .el-footer {
      height: 72px;
      line-height: 72px;
      font-size: 14px;
      color: $color-text-secondary;
      text-align: center;
      background: $body-background;
    }
  }
}
</style>

<template>
  <el-container class="vue-body">
    <el-aside>
      <sidebar :isCollapse="isCollapse" />
    </el-aside>
    <el-container class="body-container">
      <el-header>
        <navbar
          @handleChangeCollapse="changeCollapse"
          :isCollapse="isCollapse"
        />
      </el-header>
      <el-main>
        <app-main />
      </el-main>
       <!-- <el-footer> {{copyright}} </el-footer> -->
    </el-container>
  </el-container>
</template>

<script>
import Navbar from "./components/Navbar";
import AppMain from "./components/AppMain";
import Sidebar from "./components/Sidebar";
import { getGroupItemValue } from "@api/AdminUser";
import { mapActions } from "vuex"
export default {
  name: "Layout",
  components: {
    Navbar,
    AppMain,
    Sidebar,
  },
  data() {
    return {
      isCollapse: false,
      copyright : "", // 版权初始化数据
    };
  },
  computed: {},

  created() {
    // 获取初始化数据
    this.getData();
    this.initCommon();
  },
  methods: {
    ...mapActions('common', ['initCommon']),
    changeCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    async getData(){
      let { data: restitle } = await getGroupItemValue("COPYRIGHT");
      this.copyright = restitle.dgi_value ? restitle.dgi_value : "Copyright © 2022 四川创企科技有限责任公司 版权所有";
    }
  },
};
</script>
